import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import ResetPasswordUI from '../../ui/views/ResetPassword'
import { useAuthContext } from '../../auth/AuthProvider'
import useEnhancedFormik from '../../hooks/useEnhancedFormik'
import { resetPasswordPropTypes } from '../../common/propTypes'

const ResetPasswordSchema = Yup.object().shape({
  code: Yup.string().required('error:field:required'),
  //Password contains at least 1 lowercase, 1 uppercase & 1 number. Between 8-30 chars.
  password: Yup.string()
    .matches(
      '^(?=.*[a-zñ_])(?=.*[A-ZÑ_])(?=.*[0-9])(?=.{8,30})',
      'error:field:password',
    )
    .required('error:field:required'),
})

const ResetPassword = ({ forgotPasswordUsername, onResendCode }) => {
  const {
    resetPasswordState,
    setDefaultResetPasswordState,
    resetPassword,
    login,
  } = useAuthContext()

  const handleClickResendCode = () => {
    onResendCode()
    setDefaultResetPasswordState()
  }

  const formik = useFormik({
    validationSchema: ResetPasswordSchema,
    initialValues: {
      code: '',
      password: '',
    },
    onSubmit: async values => {
      await resetPassword(forgotPasswordUsername, values.code, values.password)
    },
  })

  const enhancedFormik = useEnhancedFormik(resetPasswordPropTypes, formik, {
    errors: resetPasswordState.error?.code
      ? [resetPasswordState.error.code]
      : null,
  })

  useEffect(() => {
    if (resetPasswordState?.isSuccess) {
      login(forgotPasswordUsername, formik.values.password)
    }
  }, [resetPasswordState.isSuccess])

  return (
    <ResetPasswordUI
      values={formik.values}
      touched={formik.touched}
      fieldErrors={enhancedFormik.fieldErrors}
      formErrors={enhancedFormik.formErrors}
      onChange={enhancedFormik.handleChange}
      onSubmit={enhancedFormik.handleSubmit}
      onBlur={formik.handleBlur}
      onResendCode={handleClickResendCode}
    />
  )
}

ResetPassword.propTypes = {
  forgotPasswordUsername: PropTypes.string,
  onResendCode: ResetPasswordUI.propTypes.onResendCode,
}

export default ResetPassword
